import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import Button from "../../../modules/commons/Button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleInput from "../../../modules/SimpleInput";
import Api from "../../../Services/Api";
import {HttpStatus, Status} from "../../common/Constants";
import {flattenFormGroupObject, getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../common/mapper";
import {formGroup, tableColumns} from "./config";
import MasterSuppliersFilter from "./masterSuppliersFilter";
import MasterSuppliersModifying from "./masterSuppliersModifying";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../Services/Utils";

class MasterSuppliers extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;
                    return <>{rowNumber}</>;
                },
            },
        },
        ...tableColumns,
        {
            name: "status",
            label: "Status",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <ToggleButton
                        value={R.equals(val, Status.ACTIVE)}
                        onToggle={(value) => this.handleToggleChange(value, rowIndex)}
                    />
                ),
                sort: false,
            },
        },
        {
            name: "supplierCode",
            label: "Aksi",
            options: {
                customBodyRender: (val) => {
                    return (
                        <FlexView vAlignContent="center">
                            <Button className="btnAct" onClick={() => this.handleModifyingModalVisibility(val)}>
                                <i
                                    className="fa fa-lw fa-pencil-alt"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                            <Button className="btnAct margin-left-15px" onClick={() => this.handleDelete(val)}>
                                <i
                                    className="fa fa-trash"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                        </FlexView>
                    );
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            submittedFilterData: {},
            filterData: {},
            modifyingVisible: false,
            filterVisible: false,
            selectedData: null,
            loading: false,
            limit: 5,
            page: 1,
            totalData: 0,
            namaSupplier: null,
            print: false,
            isFetch: false,
            dataTable: [],
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (_, prevState) => {
        if ((prevState.page !== this.state.page || prevState.limit !== this.state.limit) && !this.state.isFetch) {
            this.handleTriggerLoading();
            await this.fetchData(this.state.submittedFilterData, this.state.page, this.state.limit);
            this.handleTriggerLoading();
        }
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({...prevValue, loading: !prevValue.loading}));
    };

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({...prevValue, isFetch: true}));
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSupplier,
            menuName: "Master Supplier",
            setError: this.props.setError,
            args: {
                ...filter,
                page,
                limit,
            },
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            await this.setState((prevValue) => ({
                ...prevValue,
                dataTable: response.data.data,
                totalData: response.data.totalData,
                page,
                limit,
            }));
        }
        this.setState((prevValue) => ({...prevValue, isFetch: false}));
    };

    refetch = async () => {
        // await this.setState((prevValue) => ({
        //     ...prevValue,
        //     submittedFilterData: {},
        //     filterData: {},
        //     namaSupplier: null,
        //     totalData: 0,
        // }));
        await this.fetchData(this.state.submittedFilterData, this.state.page, this.state.limit);
    };

    handleToggleChange = async (value, index) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const requestBody = {
            supplierCode: this.state.dataTable[index].supplierCode,
            status: !value ? Status.ACTIVE : Status.INACTIVE,
        };
        try {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateStatusMasterSupplier,
                menuName: "Master Supplier",
                setError: this.props.setError,
                args: requestBody,
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                await this.refetch();
            }
        } catch (error) {
            // TODO
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleModifyingModalVisibility = async (id) => {
        if (!R.isNil(id)) {
            let response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterSupplierById,
                menuName: "Master Supplier",
                setError: this.props.setError,
                args: id,
            });
            if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: {
                        ...response.data.data,
                        jenisSupplier: mapToObjectDDL(
                            response.data.data.jenisSupplier.value,
                            response.data.data.jenisSupplier.keyBizpar
                        ),
                        cabang: response.data.data.cabang.map((c) =>
                            mapToObjectDDL(c.nameCabang, c.idCabang)
                        ),
                    },
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
    };

    handleDelete = async (id) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        try {
            await Api.create("NAGAMAS_MASTER_DATA").deleteMasterSupplier(id);
            await this.refetch();
        } catch (error) {
            // TODO
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleSubmitFilter = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            namaSupplier: null,
        }));
        const requestBody = {
            ...this.state.filterData,
            jenisSupplier: this.state.filterData?.jenisSupplier?.value,
            status:
                !R.isNil(this.state.filterData) && getValueFromDDL(this.state.filterData, "status")
                    ? getValueFromDDL(this.state.filterData, "status")
                    : "ACTIVE",
            cabang:
                this.state.filterData.cabang && !R.isEmpty(this.state.filterData.cabang)
                    ? this.state.filterData.cabang.map((c) => c.value)
                    : null,
        };
        await this.fetchData(removeNullFields(requestBody), 1, this.state.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
            submittedFilterData: requestBody,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleSubmitModifying = async (controls) => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
        }));
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            jenisSupplier: getValueFromDDL(formGroup, "jenisSupplier"),
            cabang: formGroup.cabang.map((value) => ({
                idCabang: value.value,
                masterSupplier: "",
            })),
        };
        try {
            if (!R.isNil(this.state.selectedData)) {
                await Api.create("NAGAMAS_MASTER_DATA").updateMasterSupplier(requestBody);
            } else {
                await Api.create("NAGAMAS_MASTER_DATA").createMasterSupplier(requestBody);
            }

            await this.refetch();
            this.handleModifyingModalVisibility();
        } catch (error) {
            // TODO
        }
        this.setState((prevValue) => ({
            ...prevValue,
            // submittedFilterData: {},
            loading: false,
        }));
    };

    handleSearchNameInput = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    handleSearch = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            filterData: {},
        }));
        await this.fetchData({
            namaSupplier: this.state.namaSupplier,
        },1 , this.state.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: {
                namaSupplier: this.state.namaSupplier,
            },
            loading: false,
        }));
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleResetFilter = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {},
        }));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            page: tableState.page + 1,
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            page: 1,
            totalData: 0,
            limit: tableState.rowsPerPage,
        }));
    };

    handlePrint = () => {
        this.setState((prevValue) => ({...prevValue, print: !prevValue.print}));
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView
                        style={{justifyContent: "space-between", alignItems: "center"}}
                        className="margin-bottom-20px margin-top-5px"
                    >
                        <FlexView vAlignContent="center">
                            <SimpleInput
                                id="input_text_nama_supplier"
                                placeholder="Nama Supplier"
                                name="namaSupplier"
                                containerclassname="margin-bottom-5px"
                                value={this.state.namaSupplier || ""}
                                onChange={({target}) => this.handleSearchNameInput(target.name, target.value)}
                            />
                            <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
                        </FlexView>
                        <Button
                            type="button"
                            className="btn background-red"
                            onClick={this.handleFilterVisibility}
                        >
              <span>
                <i className="fa fa-qrcode"></i>
              </span>
                        </Button>
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.tableColumns}
                        toCount={this.state.totalData}
                        rowsPerPage={this.state.limit}
                        page={this.state.page - 1}
                        options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                        footerAdditionalButtons={
                            <>
                                <SimpleButton onClick={() => this.handleModifyingModalVisibility()}>
                  <span>
                    <i className="fa fa-plus margin-right-10px"></i>
                  </span>
                                    Tambah
                                </SimpleButton>
                                <SimpleButton secondary onClick={this.handlePrint}>
                                    Cetak
                                </SimpleButton>
                            </>
                        }
                    />
                </Container>
                {this.state.filterVisible && (
                    <MasterSuppliersFilter
                        data={this.state.filterData}
                        visible={this.state.filterVisible}
                        onSetState={this.handleStateChange}
                        onClickClose={this.handleFilterVisibility}
                        onSubmit={this.handleSubmitFilter}
                        onReset={this.handleResetFilter}
                    />
                )}
                {this.state.modifyingVisible && (
                    <MasterSuppliersModifying
                        formGroup={formGroup}
                        initialValues={this.state.selectedData}
                        activity={!R.isNil(this.state.selectedData) ? "Edit" : "Form"}
                        visible={this.state.modifyingVisible}
                        onClickClose={this.handleModifyingModalVisibility}
                        onSubmit={this.handleSubmitModifying}
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
                {this.state.print && <SimplePrintTable onClearPrint={this.handlePrint}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterSuppliers);
